module.exports = __webpack_public_path__ + "img/90069ba.jpg";